import router from "../router"
import store from "../store"
import cookie from "@utils/store/cookie"
import { isWeixin } from "@utils"
import { oAuth } from "@libs/wechat"

export const LOGIN_BACK_URL = "login_back_url"

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT")
  const { fullPath, name } = router.currentRoute
  const loginBackUrl = backUrl || fullPath
  console.log('toLogin, push=' + push + ', loginBackUrl=' + loginBackUrl)
  cookie.set(LOGIN_BACK_URL, loginBackUrl)
  if (isWeixin()) {
    oAuth()
  } else {
    if (name !== "Login") {
      push
        ? router.push({ path: "/login" })
        : router.replace({ path: "/login" })
    }
  }
}
